var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { approveVolunteersBulkActionType, denyVolunteersBulkActionType, } from '../../../../../../../backend/features/shift/shared';
import { approvalCountToUseAsyncRequest, denyCountToUseAsyncRequest, } from '../../../../../../../ui/features/shift-details/components/shift-pending-table/utils/shiftPendingConstants';
import { useReviewParticipationsContext } from '../../../../../../../ui/features/shift-details/contexts/ReviewParticipationsContext';
import { useFormDenyConfig } from '../../../../../../../ui/features/shift-details/hooks/useFormDenyConfig';
import { getParticipationsStatuses } from '../../../../../../../ui/features/shift-details/utils/getParticipationsStatuses';
import { useMissionsTranslation } from '../../../../../../../ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { ReviewParticipationsTable } from './ReviewParticipationsTable';
import { ParticipationsStatus } from './participation-status/ParticipationsStatus';
import { ParticipationsStatusAlert } from './participation-status/ParticipationsStatusAlert';
export const ReviewParticipationsSection = ({ titleId, onSkipApproval, onBeforeApproveAll, onBeforeDenyAll, onAfterApproveAll, onAfterDenyAll, onDenyParticipation, onEmptyParticipations, }) => {
    const { validateSelectedPositions, selectedPositions, participations, removeParticipation } = useReviewParticipationsContext();
    const { t } = useMissionsTranslation();
    const formDenyConfig = useFormDenyConfig();
    const { denied, multiplePositions, oigFailed } = getParticipationsStatuses(participations);
    if (!participations.length) {
        onEmptyParticipations();
    }
    const handleDenyParticipation = (row) => {
        showFormDialog({
            title: t('shifts.pendingRequest.denyShift.title', { volunteerFullName: row.columns.participantFullName, count: 1 }),
            config: formDenyConfig,
            onSubmit: (_a) => __awaiter(void 0, [_a], void 0, function* ({ denialReason }) {
                yield onDenyParticipation(row, denialReason);
                removeParticipation(row.id);
            }),
            submitLabel: t('shifts.pendingRequest.denyShift.submitButtonText'),
        });
    };
    const handleDenyAllParticipations = () => {
        onBeforeDenyAll();
        showFormDialog({
            title: t('shifts.pendingRequest.denyShift.title', {
                volunteerFullName: participations[0].columns.participantFullName,
                count: participations.length,
            }),
            config: formDenyConfig,
            onSubmit: (_a) => __awaiter(void 0, [_a], void 0, function* ({ denialReason }) {
                const { shiftId } = participations[0].columns;
                const shiftParticipations = participations.map(({ columns, id }) => ({
                    participantId: columns.participantId,
                    participationId: id,
                }));
                launchBulkAction({
                    type: denyVolunteersBulkActionType,
                    title: t('shifts.pendingRequest.denyShift.denyingModalTitle'),
                    runSync: shiftParticipations.length < denyCountToUseAsyncRequest,
                    params: {
                        shiftParticipations,
                        shiftId,
                        status: denialReason,
                    },
                    autoCloseWhenFinished: true,
                    onClose: onAfterDenyAll,
                });
            }),
        });
    };
    const handleApproveAllParticipations = () => {
        const { valid } = validateSelectedPositions();
        if (!valid)
            return;
        onBeforeApproveAll();
        const { shiftId } = participations[0].columns;
        const shiftParticipations = participations.map((row) => {
            var _a;
            return ({
                shiftParticipationId: row.id,
                shiftParticipantId: row.columns.participantId,
                positionId: (_a = selectedPositions[row.id]) !== null && _a !== void 0 ? _a : row.columns.positionId,
                rowId: row.id,
            });
        });
        launchBulkAction({
            type: approveVolunteersBulkActionType,
            title: t('shifts.pendingRequest.approveShift.approvingModalTitle'),
            autoCloseWhenFinished: true,
            runSync: shiftParticipations.length < approvalCountToUseAsyncRequest,
            params: {
                shiftId,
                shiftParticipations,
                totalShiftParticipations: participations.length,
            },
            onClose: onAfterApproveAll,
        });
    };
    return (React.createElement(Stack, { p: 3, gap: 2 },
        React.createElement(Typography, { id: titleId, variant: 'h6' }, t('shifts.pendingRequest.review.title')),
        React.createElement(ParticipationsStatus, { denied: denied, multiplePositions: multiplePositions, oigFailed: oigFailed }),
        React.createElement(Box, { bgcolor: themeColors.surface.secondary, borderRadius: 0.5, p: 2 },
            React.createElement(Stack, { gap: 2 },
                React.createElement(ParticipationsStatusAlert, { denied: denied, multiplePositions: multiplePositions, oigFailed: oigFailed }),
                React.createElement(ReviewParticipationsTable, { participations: participations, onDenyParticipation: handleDenyParticipation }))),
        React.createElement(Stack, { gap: 2, direction: 'row', justifyContent: 'right' },
            React.createElement(Button, { onClick: onSkipApproval }, t('shifts.pendingRequest.review.actions.skip')),
            React.createElement(Button, { onClick: handleDenyAllParticipations }, t('shifts.pendingRequest.review.actions.denyAll')),
            React.createElement(Button, { onClick: handleApproveAllParticipations }, t('shifts.pendingRequest.review.actions.approveAll')))));
};
